import React from 'react';
import{ isEmpty, get, forEach, cloneDeep } from 'lodash';

import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsStepFlow as WidgetsStepFlowView } from 'modules/widgetsStepFlow';
import { widgetsStepFlowPreloader as WidgetsStepFlowPreloader } from 'modules/widgetsStepFlow';
import { pageLevelSuccessAcknowledgement as PageLevelSuccessAcknowledgement } from 'ui/views/widgets/pageLevelSuccessAcknowledgement';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { enrollToEpost as EnrollToEpost } from 'ui/views/widgets/enrollToEpost';
 *
 * // render
 * <EnrollToEpost propName='propValue'/>
 */
const _enrollToEpost = ( props ) => {

    if( isEmpty( get( props, 'successView', {} ) ) ) {

        return (
            <div className='ui-enroll-to-epost'>
                <WidgetsStepFlowView
                    activeStepIndex={ props.currentStep - 1 }
                    steps={ props.steps }
                    requestPayload={ props.requestPayload }
                />
            </div>
        );
    } else {

        const { origin } = props;
        const successView = cloneDeep( props.successView );

        const navAction = [];

        forEach( successView.navActions, action => {

            if( 'verification' === origin && 'backToVerification' === action.name ) {

                navAction.push( action );

            } else if( 'verification' !== origin && 'backToVerification' !== action.name ) {

                navAction.push( action );
                
            }
        } );
        

        successView.navActions = navAction;

        return(
            <div className='ui-checkout'>
                <PageLevelSuccessAcknowledgement
                    { ...successView  }
                    onActionClick = { props.onSuccessfullEnrollment }
                    type={ 'default' } />
            </div>
        );
    }
};

// set display name
_enrollToEpost.displayName = 'enrollToEpost';

// set default props
_enrollToEpost.defaultProps = {
    currentStep: 1,
    requestPayload: {},
};

// prop types
_enrollToEpost.propTypes = {};

/*******************************/

// preloader widget view
const enrollToEpostPreloader = () => {
    return (
        <div className='ui-enroll-to-epost-preloader'>
            <WidgetsStepFlowPreloader />
        </div>
    );
};

// set display name
enrollToEpostPreloader.displayName = 'enrollToEpostPreloader';

// set default props
enrollToEpostPreloader.defaultProps = {};

// prop types
enrollToEpostPreloader.propTypes = {};

/*******************************/

export const enrollToEpost = withNetworkState( enrollToEpostPreloader, _enrollToEpost );
